import * as React from "react";
import { ajax, BotService } from "../../Generated/RestClient";
import { TabControl, TabProps } from "./TabControl";
import { BotTabs } from "./BotPage";
import { RuntimeConnectedShade, resourceStrings } from "../../../../Intercom.ReactUI/Views/index";
import { BotTypes, BotUtils, BotUtilsV2 } from "../../Utils/BotUtils";
import { CompactDropdownControl } from "./CompactDropdownControl";
import { MasterPageHeader } from "./MasterPageHeader";
import { ControllerBase } from "../Controllers/ControllerBase";
import { Environment } from "../../../../Intercom.ReactUI/Utils/Environment";
import { IAnnouncements } from "../../DevPortalAppBase";
import { MessageBox } from '../../Dialogs/MessageBox';

export interface Route {
    tab: BotTabs;
    route: string;
}

export interface BotPageHeaderProps extends React.Props<BotPageHeader> {
    bot: BotService;
    selectedTab: BotTabs;
    controller: ControllerBase;
    authoringToolDirty: boolean;
    showWebChat?: boolean;
    isAdmin: () => boolean;
    isReviewer: () => boolean;
    tabClickHandler: (tab: BotTabs) => void;
    testClickHandler: () => void;
    importBotHandler: (file: any) => JQueryPromise<any>;
    routes(botType: BotTypes): Route[];
    announcements: IAnnouncements;
}

function startMigration(bot: BotService, success: (url: string) => void, error: (xhr: JQueryXHR,  status: string, e:string) => void)  {
    return ajax({
        url: `/api/botManager/MigrateBot?botId=${bot.Id}`,
        type: 'POST',
        dataType: 'json',
        // set async false to work around popup blocker. Yes, this freezes the UI
        // but to make async stateful dialog work in a clean way is overkill for this
        // occasionally used feature (namely migrate team bot to Azure)
        async: false,
        success,
        error
    });
}

export class BotPageHeader extends React.Component<BotPageHeaderProps, {}> {

    private renderBotName(): JSX.Element {
        if (Environment.isInAzurePortal) {
            return null;
        }

        const botNameLabel = BotUtilsV2.isAzureIbizaBot(this.props.bot) && this.props.isAdmin ? "[Azure Bot] " + this.props.bot.Name : this.props.bot.Name;
        return (
            <div className="bot-name">{botNameLabel}</div>
        );
    }

    private renderMigration() : JSX.Element {
        if (!this.props.bot.Kind) {
            return <button type="button" className="m-button" onClick={() => {
                startMigration(this.props.bot, url => window.open(url, '_blank'), (xhr, status, error) => MessageBox.show(error));
            }}>Migrate</button>;
        }

        return null;
    }

    private renderControls(botType: BotTypes): JSX.Element {
        let testButtonClass = "m-button-primary-md bot-test-button bot-test-button";
        testButtonClass += this.props.showWebChat ? "-close" : "-open";

        return (
            <div className="bot-controls">
                {this.renderMigration()}
                <button type="button" className={testButtonClass} onClick={() => this.props.testClickHandler()}>Test</button>
            </div>
        );
    }

    private renderTabs(botType: BotTypes, className: string): JSX.Element {
        let tabs:TabProps[] = this.props.routes(botType).map((route) => {
            return {
                tab: route.tab,
                label: resourceStrings.v4.botPageTabs[route.tab]
            }
        });
        return (
            <div className={className}>
                <TabControl
                    tabs={tabs}
                    selectedTab={this.props.selectedTab}
                    clickHandler={this.props.tabClickHandler}
                    className="bot-tab-control"
                    tabClassName="bot-tab-control-tab"
                    selectedClassName="bot-selected-tab"
                    botId={this.props.bot.Id}
                />
            </div>
        );
    }

    public renderCompactMenu(botType: BotTypes): JSX.Element {
        return (
            <div>
                {this.renderTabs(botType, "bot-compact-tabs")}
                <div className="bot-compact-links">
                    <MasterPageHeader
                        controller={this.props.controller}
                        showLinks={true}
                        showUserMenu={false}
                        showSearch={false}
                        showEnvironment={false}
                        showMainNavLink={false}
                        isAdmin={() => this.props.isAdmin()}
                        isReviewer={() => this.props.isReviewer()}
                        signedInUser={null}
                        renderHiddenFrameToCheckAzureSingleSignOn={null}
                        onSearch={(s: string) => { }}
                        onSignOutClicked={null}
                        onAccountClicked={null}
                        showJumboHeader={false}
                        isRoutableUrl={null}
                        announcements={this.props.announcements}
                    />
                </div>
            </div>
        )
    }

    public render(): JSX.Element {
        // Hide the entire header in Ibiza
        if (Environment.isInBotFrameworkAzureExtension) {
            return null;
        }

        let botType = BotUtils.getBotType(this.props.bot);
        return (
            <div className="bot-page-header cover-container">
                <CompactDropdownControl
                    className="bot-compact-menu"
                    contentClassName="bot-compact-menu-content"
                    closeOnClick={true}
                    content={this.renderCompactMenu(botType)} />
                {this.renderBotName()}
                {this.renderEditMark()}
                <div className="flex-spacer" />
                {this.renderTabs(botType, "bot-tabs")}
                {this.renderControls(botType)}
                <RuntimeConnectedShade></RuntimeConnectedShade>
            </div>
        );
    }

    private renderEditMark(): JSX.Element {
        if (this.props.authoringToolDirty) {
            return <div className="bot-edited">Edited *</div>
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotPageHeader.tsx